import { OrganisationRelationshipResult } from '@percent/domain/verifications'
import { SimilarOrganisation } from '@percent/admin-dashboard/api/types'
import { renderAddressString } from '@percent/admin-dashboard/common/utility/renderAddressString'

export const getOrgOptionDescription = (org: SimilarOrganisation | OrganisationRelationshipResult) => {
  const { website, address } = org

  const formattedAddress = renderAddressString(address)

  if (website && formattedAddress) {
    return `${formattedAddress} \n ${website}`
  }

  return formattedAddress || website || ''
}
